<div class="counter" [ngClass]="style">
  <h4>{{ title }}</h4>
  <p>{{ value }}</p>
  <button (click)="emitIncrease()"><span>+</span></button>
</div>
